export const CHANGE_RESET_PASSWORD_FORM_FIELD = 'CHANGE_RESET_PASSWORD_FORM_FIELD' as const
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST' as const
export const RESET_PASSWORD_REQUEST_SUCCESS = 'RESET_PASSWORD_REQUEST_SUCCESS' as const
export const RESET_PASSWORD_REQUEST_FAILURE = 'RESET_PASSWORD_REQUEST_FAILURE' as const
export const VALIDATE_RESET_PASSWORD_FIELD = 'VALIDATE_RESET_PASSWORD_FIELD' as const
export const ADD_RESET_PASSWORD_FIELD_ERROR = 'ADD_RESET_PASSWORD_FIELD_ERROR' as const
export const CLEAR_RESET_PASSWORD_FIELD_ERROR = 'CLEAR_RESET_PASSWORD_FIELD_ERROR' as const

export function changeResetPasswordFormField(key: string, value: string) {
  return { type: CHANGE_RESET_PASSWORD_FORM_FIELD, payload: { key, value } }
}

export function resetPasswordRequest(p: {
  password: { value: string; validations?: string }
  jwt: { value: string; validations?: string }
}) {
  return { type: RESET_PASSWORD_REQUEST, payload: p }
}

export function resetPasswordFailure(errors: Record<string, string>) {
  return { type: RESET_PASSWORD_REQUEST_FAILURE, errors }
}

export function resetPasswordSuccess() {
  return { type: RESET_PASSWORD_REQUEST_SUCCESS }
}

export function addFieldError({ field, error }: { field: string; error: string }) {
  return { type: ADD_RESET_PASSWORD_FIELD_ERROR, payload: { error, field } }
}

export function clearFieldError({ field }: { field: string }) {
  return { type: CLEAR_RESET_PASSWORD_FIELD_ERROR, payload: { field } }
}

export function validateField({
  field,
  value,
  validations,
}: {
  field: string
  value: string
  validations?: string
}) {
  return { type: VALIDATE_RESET_PASSWORD_FIELD, payload: { field, value, validations } }
}
